/* eslint-disable no-new */
/* eslint-disable import/prefer-default-export */
import JsFileDownloader from 'js-file-downloader';
import { useCallback } from 'react';
import { baseUrl } from '../_config';
import { trackHotjarEvent } from '../_lib/hotjar';

type downloadFileParams = {
  hasHost: boolean;
  url: string;
  filename: string;
};

export const useDownloadFile = () => {
  const downloadFile = useCallback(({ hasHost, url }: downloadFileParams): void => {
    const hostUrl = baseUrl.split('/').slice(0, 3).join('/');
    const endpointUrl = `${hostUrl}${url}`;
    const urlResultant = hasHost ? url : endpointUrl;

    window.open(urlResultant, '_blank', 'noopener,noreferrer');
    trackHotjarEvent('file_download_opened');
  }, []);

  return [downloadFile];
};
